import script from "./loadError.vue?vue&type=script&setup=true&lang=js"
export * from "./loadError.vue?vue&type=script&setup=true&lang=js"

import "./loadError.vue?vue&type=style&index=0&id=65b7a165&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b7a165"]])

export default __exports__